import React, { } from "react";
import { Col, Row } from "reactstrap";
import PlanBlock from './PlanBlock';
import "./index.scss";
const PlansWrapper = ({ plans, _handlePlans }) => {

    return (
        <>
            <div className="plans-wrapper">
                <Row>
                    {plans && plans.map((item, ind) => (
                        item && <Col key={ind} md="6" lg="4" xl="2" className="d-flex flex-column flex-fill">
                            <PlanBlock plan={item} _handlePlans={_handlePlans} />
                        </Col>))}

                </Row>
            </div>
        </>
    )
};
export default PlansWrapper;